import React from 'react';
import DefaultLayout from '../../../layout/DefaultLayout';
import ReportProfilePanel from '../../../components/settings/reportprofile/ReportProfilePanel';
import BreadcrumbTwo from '../../../components/Breadcrumbs/BreadcrumbTwo';

const ReportsConfigPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <ReportProfilePanel />
    </DefaultLayout>
  );
};

export default ReportsConfigPage;
